import { useContext } from "react";
import { VehicleReservationContext } from "./VehicleReservationProvider";

const useVehicleReservation = () => useContext(VehicleReservationContext);

export { useVehicleReservation };
